import imgNoPoster from '../../images/no-poster/noposter.jpg';

export default {
  NOPOSTER: imgNoPoster,
};
